import type { ApiClient } from '../../api/client';
import type { ImpersonationTarget as ApiImpersonationTarget } from '../../api/types';
import {
  fixtureImpersonationTargets,
  type ImpersonationPort,
  type ImpersonationTarget,
} from '../../features/security/public';
import {
  clearFixtureImpersonation,
  storeFixtureImpersonation,
} from '../../fixtures/session';

function toImpersonationTarget(target: ApiImpersonationTarget): ImpersonationTarget {
  return {
    identityId: target.identityId,
    personId: target.personId,
    workerId: target.workerId,
    displayName: target.displayName,
    workerNumber: target.workerNumber,
    organization: target.organization,
  };
}

export function createImpersonationAdapter(client: ApiClient, fixtureMode: boolean): ImpersonationPort {
  return {
    async listTargets(search) {
      if (!fixtureMode) {
        const response = await client.listImpersonationTargets(search);
        return { total: response.total, data: response.data.map(toImpersonationTarget) };
      }

      const normalized = search.trim().toLowerCase();
      const targets = normalized
        ? fixtureImpersonationTargets.filter((target) => (
          `${target.displayName} ${target.workerNumber} ${target.organization}`.toLowerCase().includes(normalized)
        ))
        : fixtureImpersonationTargets;
      return { total: targets.length, data: targets.map(toImpersonationTarget) };
    },
    start({ targetIdentityId, purposeCode }) {
      if (!fixtureMode) {
        return client.startImpersonation(targetIdentityId, purposeCode);
      }

      const target = fixtureImpersonationTargets.find((candidate) => candidate.identityId === targetIdentityId);
      if (!target) return Promise.reject(new Error('전환할 사용자를 확인할 수 없습니다.'));
      storeFixtureImpersonation(target, purposeCode);
      return Promise.resolve();
    },
    stop() {
      if (fixtureMode) {
        clearFixtureImpersonation();
        return Promise.resolve();
      }
      return client.stopImpersonation();
    },
  };
}
